import { Vue } from "vue-property-decorator";
import TheHeader from "@/components/TheHeader/TheHeader.vue";
import TheFooter from "@/components/TheFooter/TheFooter.vue";
import VLangToggle from "@/components/VLangToggle/VLangToggle.vue";
import VLoginButton from "@/components/VLoginButton/VLoginButton.vue";
import VSideLinks from "@/components/VSideLinks/VSideLinks.vue";
import VShareNetwork from "@/components/VShareNetworks/VShareNetwork.vue";
import TheMoveToTopButton from "@/components/TheMoveToTopButton/TheMoveToTopButton.vue";

Vue.component("VLangToggle", VLangToggle);
Vue.component("VLoginButton", VLoginButton);
Vue.component("VSideLinks", VSideLinks);
Vue.component("VShareNetwork", VShareNetwork);

Vue.component("TheMoveToTopButton", TheMoveToTopButton);
Vue.component("TheHeader", TheHeader);
Vue.component("TheFooter", TheFooter);
